import { Component, OnInit } from '@angular/core';
import { UserService, ContextService, CommandeService, SigninService, CartService } from '../../shared';
import { User, Panier, LignePanier } from '../../shared';
import { environment } from '../../../environments/environment';
import * as html2c from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  context: string;
  currentUser: User;
  isAuthed: boolean;
  imgfolder_url: string;

  panier: Panier;
  articles: Array<LignePanier> = [];
  total: number = 0;
  commande: any;
  adresseEmail: string;
  adresseFacturation: any = {};
  adresseLivraison: any = {};
  today = Date.now();

  constructor(
  	private userService: UserService,
    private cartService: CartService,
    private contextService: ContextService,
    private commandeService: CommandeService,
    private signinService: SigninService,
  ) {}

  ngOnInit() {

   
    this.imgfolder_url = environment.imgfolder_url;

    this.context = this.contextService.getContext();
    this.userService.currentUser.subscribe(
      data => {
 
        this.currentUser = data;
      
        this.commande = JSON.parse(sessionStorage.getItem("commande_hachette_kne"));
        this.adresseFacturation = JSON.parse(sessionStorage.getItem("fac_hachette_kne"));
        this.adresseLivraison = JSON.parse(sessionStorage.getItem("liv_hachette_kne"));
        this.signinService.getPays(this.adresseFacturation.idPaysLPC).subscribe(
          pays => {
            this.adresseFacturation.paysLibelle = pays;
          }
        );
        this.adresseEmail = this.commande.mailLivraison;
        console.log(this.commande)
        console.log(this.adresseFacturation)
        console.log(this.adresseLivraison)
        this.cartService.destroyLocalCart();
        this.cartService.destroyCart()
        this.cartService.deleteCart()
       // this.getCart();
      }
    );

    

   

    this.userService.isAuthenticated.subscribe(
      (authData) => {
        this.isAuthed = authData;
      }
    );

   

  }

  getCart(){
    /*this.total = 0;

    this.panier = this.cartService.getLocalCart();
    this.articles = this.panier.lignePanier;
    this.articles.forEach( function(a){
      this.total += a.quantite * a.prixUnitaireTTC;
    }, this);
    this.total += this.panier.montantFraisDePort;*/

   

    
  }

  downloadRecap(){
    let el = document.getElementById('recap');

    html2c(el).then( canvas => {
      console.log(canvas);
      var data = canvas.toDataURL();
      var docDefinition = {
        content: [
          {
            image: data,
            width: 510
          }
        ]
      };
      pdfMake.createPdf(docDefinition).download('recapitulatif-commande.pdf');
    });
  }

  dateFormat(date: string){
    // console.log(date);
    return new Date(date).toLocaleDateString().replace(/-/g, "/");
  }

}



// WEBPACK FOOTER //
// ./src/app/user/_confirm/confirm.component.ts